import axios from 'axios';
import { getFromStorage, setToStorage } from './localStorage';
import store from '@/store';

// create an axios instance with default options
const http = axios.create({ baseURL: window.location.origin });

// const http = axios.create({ baseURL: 'https://artist-blkexp.geeq-test.io' });
// const http = axios.create({ baseURL: 'https://s2-vipstack.geeqsearch.io' });
// const http = axios.create({ baseURL: 'https://open.geeqsearch.io' });
// const http = axios.create({ baseURL: 'https://blkexp.geeq-test.io' });
// const http = axios.create({ baseURL: 'https://oasis.geeqlabs.io' });
// const http = axios.create({ baseURL: 'http://localhost:4000' });
// const http = axios.create({ baseURL: 'https://hydrogen.geeqsearch.io' });
// const http = axios.create({ baseURL: 'https://h2.geeqsearch.io' });
// const http = axios.create({ baseURL: 'https://geeq-hamo-blkexp.geeq-test.io' });

// const http = axios.create({
//   baseURL: 'https://6d13-37-252-84-150.ngrok-free.app',
//   headers: {
//     'ngrok-skip-browser-warning': 'true'
//   }
// });

// Define Middleware for axios request
http.interceptors.request.use(
  (config) => {
    const token = getFromStorage("token");
    const encodedToken = token ? encodeURIComponent(token) : "";
    // eslint-disable-next-line no-param-reassign
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${encodedToken}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// Define Middleware for axios response
http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403) && !error.config._retry) {
      error.config._retry = true;
      const refreshToken = getFromStorage("refreshToken");
      return http.post("/api/admin/auth/exchange", { token: refreshToken })
        .then((res) => {
          const result = res.data?.result;
          if (result?.access) {
            setToStorage('token', result.access);
            if (result.refresh) {
              setToStorage('refreshToken', result.refresh);
            }
            const newToken = encodeURIComponent(result.access);
            error.config.headers.Authorization = `Bearer ${newToken}`;
            return http.request(error.config);
          }
          store.dispatch('LOGOUT');
          return Promise.reject(error);
        })
        .catch((err) => {
          console.error('Error refreshing token:', err);
          store.dispatch('LOGOUT');
          return Promise.reject(err);
        });
    }
    return Promise.reject(error);
  }
);

export default {
  async getAddedNodes(limit: number, skip: number) {
    return http.get(`/api/admin/nodes?limit=${limit}&skip=${skip}`);
  },
  addNode(node: any) {
    return http.post("/api/admin/nodes", node);
  },
  updateNode(node: any) {
    return http.put(`/api/admin/nodes/${node.id}`, node);
  },
  pauseNode(id: number) {
    return http.post(`/api/admin/nodes/${id}/pause`);
  },
  resumeNode(id: number) {
    return http.post(`/api/admin/nodes/${id}/resume`);
  },
  deleteNode(id: number) {
    return http.delete(`/api/admin/nodes/${id}`);
  },
  // To Do : 'Implement new search single Endpoint',
  async searchBlockchainBySearchStr(searchStr: string) {
    console.log('======Searching blockchain with search string:', searchStr);
    let searchParam = searchStr;
    searchParam = encodeURIComponent(searchStr);
    return http.get(`/api/search?text=${searchParam}`);
  },
  async searchBlockchainBySearchType(type: string, value: string, limit: number, skip: number) {
    let searchParam = value;
    searchParam = encodeURIComponent(value);
    return http.get(`/api/search/byType?text=${searchParam}&type=${type}&limit=${limit}&offset=${skip}`);
  },
  async getNftById(id: string, chainNumber: number) {
    let searchParam = id;
    searchParam = encodeURIComponent(id);
    return http.get(`/api/nfts/byId/${searchParam}?chainNumber=${chainNumber}`);
  },
  async getTransactionsByType(params: {
    accountNumApp?: string,
    block?: number,
    blockNumber?: number,
    chainNumber?: number,
    type?: Array<string>,
    minBlock?: number,
    maxBlock?: number,
    dateFrom?: string | number | Date,
    dateTo?: string | number | Date,
    from?: string,
    to?: string,
    status?: Array<string>,
    limit?: number,
    skip?: number
  }) {
    const queryParams = new URLSearchParams();

    if (params.accountNumApp) queryParams.append('accountNumApp', encodeURIComponent(params.accountNumApp));
    const blockNumber = params.blockNumber ?? params.block;
    if (blockNumber !== undefined) queryParams.append('blockNumber', blockNumber.toString());
    if (params.chainNumber !== undefined) queryParams.append('chainNumber', params.chainNumber.toString());
    if (params.type && params.type.length > 0) {
      params.type.forEach(t => queryParams.append('type', t));
    }
    if (params.minBlock !== undefined) queryParams.append('minBlock', params.minBlock.toString());
    if (params.maxBlock !== undefined) queryParams.append('maxBlock', params.maxBlock.toString());
    if (params.dateFrom !== undefined) {
      const dateFrom = params.dateFrom instanceof Date ? params.dateFrom.toISOString() : params.dateFrom.toString();
      queryParams.append('dateFrom', dateFrom);
    }
    if (params.dateTo !== undefined) {
      const dateTo = params.dateTo instanceof Date ? params.dateTo.toISOString() : params.dateTo.toString();
      queryParams.append('dateTo', dateTo);
    }
    if (params.from) queryParams.append('from', encodeURIComponent(params.from));
    if (params.to) queryParams.append('to', encodeURIComponent(params.to));
    if (params.status && params.status.length > 0) {
      params.status.forEach(s => queryParams.append('status', s));
    }
    if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
    if (params.skip !== undefined) queryParams.append('skip', params.skip.toString());

    return http.get(`/api/transactions?${queryParams.toString()}`);
  },
  getCoinAccountDetails(address: string, chainNumber: number) {
    return http.get(`/api/accounts/${address}?chainNumber=${chainNumber}`);
  },
  getProxyFundingAccountDetails(address: string, chainNumber: number) {
    return http.get(`/api/accounts/proxy/funding/${address}?chainNumber=${chainNumber}`)
  },
  getProxyAccountsForCoinAccount(address: string, chainNumber: number) {
    return http.get(`/api/accounts/managedBy/${address}?chainNumber=${chainNumber}`)
  },
  getBlockByNumber(number: number, chainNumber: number) {
    return http.get(`/api/blocks/byNumber?number=${number}&chainNumber=${chainNumber}`)
  },
  getChainByNumber(number: number) {
    return http.get(`/api/chains/byNumber?number=${number}`)
  },
  searchByBlockNumber(number: number, limit: number, skip: number) {
    return http.get(`/api/blocks/${number}?limit=${limit}&skip=${skip}`)
  },
   getTransactionDetailsByRefHash(txRefHash: string) {
    return http.get(`/api/transactions/byRefHash?refHash=${txRefHash}`)
  },

  login(username: string, password: string) {
    return http.post("/api/admin/auth/login", { username, password });
  },
  resetPassword(oldPassword: string, newPassword: string) {
    return http.post("/api/admin/users/change-password", { oldPassword, newPassword });
  },
  getAuthUser() {
    return http.get("/api/users");
  },
  getChainDetails(id: number) {
      return http.get(`/api/chain/${id}`)
  },



  searchByHashOrMeta(type: string, searchStr: string, limit: number, skip: number) {
    let searchParam = searchStr;
    if (type !== "hash") {
      searchParam = encodeURIComponent(searchStr);
    }
    return http.get(`/api/blocks?type=${type}&search=${searchParam}&limit=${limit}&skip=${skip}`)
  },
  searchByRefhash(searchStr: string) {
    let searchParam = searchStr;
    searchParam = encodeURIComponent(searchStr);

    return http.get(`/api/blocks/ref-hash?refHash=${searchParam}`)
  },
  searchByMetadata(type: string, searchStr: string, limit: number, skip: number) {
    let searchParam = searchStr;
    searchParam = encodeURIComponent(searchStr);

    return http.get(`/api/blocks/meta-search?searchType=${type}&search=${searchParam}&limit=${limit}&skip=${skip}`)
  },
  searchNftByMetadata(type: string, searchStr: string, limit: number, skip: number) {
    let searchParam = searchStr;
    searchParam = encodeURIComponent(searchStr);

    return http.get(`/api/blocks/meta-search-nft?searchType=${type}&search=${searchParam}&limit=${limit}&skip=${skip}`)
  },
  searchByBlockNumbers(numbers: Array<number>) {
    return http.get(`/api/blocks/byNumber`, {
      params:{
        numbers: numbers,
      }
    })
  },
  getTransactionTypes() {
    return http.get(`/api/transactions/types`)
  },
  getDocument(id: number) {
      return http.get(`/api/document/${id}`)
  },
  // getBlockByNumber(number: number) {
  //   return http.get(`/api/blocks/${number}`)
  // },
  getAllTransactionsForAccount(accountNumVal: string, limit: number, skip: number) {
    return http.get(`/api/transactions/transactions?accountNumVal=${accountNumVal}&limit=${limit}&skip=${skip}`)
  },
  getAccountNftTransactions(accountNumVal: string, limit: number, skip: number) {
    return http.get(`/api/transactions/nft-tab?accountNumVal=${accountNumVal}&limit=${limit}&skip=${skip}`)
  },
  getAccountNfts(accountNumVal: string) {
    return http.get(`/api/nftMints/nft-tab?accountNumVal=${accountNumVal}`)
  },
  getOwnedNftsForAccount(account: string, chainNumber?: number) {
    const queryParams = new URLSearchParams();

    queryParams.append('account', account);
    if (chainNumber !== undefined && chainNumber !== null) {
      queryParams.append('chainNumber', chainNumber.toString());
    }

    return http.get(`/api/nfts?${queryParams.toString()}`)
  },
  getTransactionDetailsByHash(hash: string) {
    return http.get(`/api/transactions?hash=${hash}`)
  },
  getTransactionDetailsByNotaryId(notaryPayloadId: number) {
    return http.get(`/api/transactions?notaryPayloadId=${notaryPayloadId}`)
  },
  getTransactionByCounterpartyId(id: number) {
    return http.get(`/api/stacks/${id}`)
  },
  getStackTransactionsById(stackId: number, limit: number, skip: number) {
    return http.get(`/api/transactions?stackId=${stackId}&limit=${limit}&skip=${skip}`)
  },
  getCsv(from: number, to: number) {
    return http.get(`/api/export/transaction?from=${from}&to=${to}`)
  },
  searchByStackId(stackId: number) {
    return http.get(`/api/stacks/${stackId}`)
  },
  getCoinAccountDetailsOld(address: string) {
    return http.get(`/api/coinAccount?acctNumVal=${address}`)
  },
  getCoinAccountTransactions(address: string, limit: number, skip: number) {
    return http.get(`/api/transactions?acctNumVal=${address}&limit=${limit}&skip=${skip}`)
  },
  getProxyAccountDetails(address: string) {
    return http.get(`/api/proxyAccount?acctNumVal=${address}`)
  },
  getProxyAccountTransactions(address: string, limit: number, skip: number) {
    return http.get(`/api/transactions/proxyTransactions?accountNumVal=${address}&limit=${limit}&skip=${skip}`)
  },
  getProxyNftMintAccountDetails(address: string, chainNumber: number) {
    return http.get(`/api/accounts/proxy/nftMint/${address}?chainNumber=${chainNumber}`)
  },
  getProxyTokenMintAccountDetails(address: string, chainNumber: number) {
    return http.get(`/api/accounts/proxy/tokenMint/${address}?chainNumber=${chainNumber}`)
  },
  // getNftById(id: string) {
  //   return http.get(`/api/nftMints/${id}`)
  // }
};
